// extracted by mini-css-extract-plugin
export default {"main":"styles_main__hrBmF","config-loading":"styles_config-loading__ZEokd"};